
import React from 'react'
import competencias from '../images/propuesta-escolar/competencias.jpg';
import idiomas from '../images/propuesta-escolar/idiomas.jpg';
import arte from '../images/propuesta-escolar/arte.jpg';
import clubes from '../images/propuesta-escolar/clubes.jpg';
import deporte from '../images/propuesta-escolar/deporte.jpg';
import stream from '../images/propuesta-escolar/stream.jpg';
import abp from '../images/propuesta-escolar/abp.jpg';
import visionAmbiental from '../images/propuesta-escolar/vision-ambiental.jpg';
import herramientas from '../images/propuesta-escolar/herramientas.jpg';
import nurseryimg from '../images/nurser-babe.jpg';
import cuarentaimg from '../images/40.png';

export class Propuesta extends React.Component {
	render() {
		return (
			<>
				<section className="propuestaSection">
						<div className="wrapContentIner">
						<h2>EXPLORA NUESTRA PROPUESTA</h2>
						</div>

						<div className="propuestaGrid">
								<div className="propFraction">
									<img src={competencias} alt="IPICIM preescolar primaria secundaria primary high school english steam"/>
									<div className="blueBox"></div>
									<span>Competencias<br/>
												Siglo XX1</span>
								</div>
								<div className="propFraction">
									<img src={idiomas} alt="IPICIM preescolar primaria secundaria primary high school english steam"/>
									<div className="blueBox"></div>
									<span>Idiomas</span>
								</div>
								<div className="propFraction">
									<img src={clubes} alt="IPICIM preescolar primaria secundaria primary high school english steam"/>
									<div className="blueBox"></div>
									<span>Clubes</span>
								</div>
								<div className="propFraction">
									<img src={arte} alt="IPICIM preescolar primaria secundaria primary high school english steam"/>
									<div className="blueBox"></div>
									<span>Arte</span>
								</div>
								<div className="propFraction">
									<img src={deporte} alt="IPICIM preescolar primaria secundaria primary high school english steam"/>
									<div className="blueBox"></div>
									<span>Deporte</span>
								</div>
								<div className="propFraction">
									<img src={stream} alt="IPICIM preescolar primaria secundaria primary high school english steam"/>
									<div className="blueBox"></div>
									<span>STREAM</span>
								</div>
								<div className="propFraction">
									<img src={abp} alt="IPICIM preescolar primaria secundaria primary high school english steam"/>
									<div className="blueBox"></div>
									<span>ABP</span>
									<span className="peq">Aprendizaje <br/>
									basado en proyectos</span>
								</div>
								<div className="propFraction">
									<img src={visionAmbiental} alt="IPICIM preescolar primaria secundaria primary high school english steam"/>
									<div className="blueBox"></div>
									<span>Visión<br/>
										ambiental</span>
								</div>
								<div className="propFraction">
									<img src={herramientas} alt="IPICIM preescolar primaria secundaria primary high school english steam"/>
									<div className="blueBox"></div>
									<span>Herramientas<br/>
								para la vida</span>
								</div>
						</div>
				</section>

				<section className="nursery">
					<img src={nurseryimg} alt="IPICIM preescolar primaria secundaria nursery primary high school english steam"/>
					<a href="###" className="btn1">Ver más</a>
				</section>
				
				<section className="cuarentanos">
					<div className="wrapper40">
						<div className="cuarentaimg">
							<img src={cuarentaimg} alt="IPICIM 40 años experiencia preescolar primaria secundaria nursery primary high school english steam"/></div>
						<div className="cuarentamsj">
							<p>años de<br/>
							experiencia</p>
							<a href="###" className="btn2">Ver más</a>
						</div>
					</div>
				</section>

			</>
		)
	}
}

export default Propuesta